export function addDays(date, days) {
  let result = new Date(date)

  result.setDate(result.getDate() + days)
  return result
}

export function subtractDays(date, days) {
  let result = new Date(date)

  result.setDate(result.getDate() - days)
  return result
}

export function formatDateForOnlineRequest(date) {
  if (!date) return null

  return date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate() ).slice(-2)
}

export function formatDateTimeForOnlineRequest(date) {
  let result = formatDateForOnlineRequest(date)

  if (date.getHours()) {
    result += ` ${date.getHours()}:${date.getMinutes()}`
  }

  return result
}
